// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"BdcWinsDemandModal_modalContainer__NX38W","modalText":"BdcWinsDemandModal_modalText__3TgPG","buttonContainer":"BdcWinsDemandModal_buttonContainer__KkZyS"};